export enum SESSION_KEYS {
  SITE_CORRELATION_ID = "siteCorrelationId",
  UI_FLOW_PREFERENCES = "uiFlowPreferences",
  USER_PROFILE_DATA = "userProfileData",
  SITE_TECHNICAL_DATA = "siteTechnicalData",
  TARIFFS = "tariffs",
  BONUS = "bonus",
  TRANSFER_ID = "transferId",
  SALES_PARTNER_ID = "salesPartnerId",
  FUNNEL_ORDER_RESPONSE = "funnelOrderResponse",
  SMART_CHARGING_WALLBOX_DATA = "smartChargingWallboxData",
  CORRELATION_ID = "correlationId",
  REDIRECT_URL = "redirectUrl",
  MFE_CUSTOMER_ACCESS = "mfeCustomerAccess",
  MICRO_FRONTEND_DETAILS = "microFrontendDetails",
  SELF_ONBOARDING_OEM_SELECTED = "selfOnboardingOemSelected",
  EVSES_COMPATIBILITY = "evsesCompatibility",
  EVSE_SELF_ONBOARDING_DETAILS = "evseSelfOnboardingDetails",
  ORCHESTRATION_INFO = "orchestrationInfo",
  IS_COMP_CHECK_FROM_SELL = "isCompCheckFromSell",
  ORCHESTRATION = "orchestration",
}

export interface UI_FLOW_PREFERENCES {
  language?: string;
  callbackUrlSuccess?: string;
  callbackUrlFailure?: string;
  processType?: string;
  skipOemAuth?: string;
  skipSaleProcess?: string;
}

export interface USER_PROFILE_DATA {
  firstName?: string;
  lastName?: string;
  mobileNumber?: string;
  email?: string;
  confirmEmail?: string;
  street?: string;
  houseNumber?: string;
  zipCode?: string;
  city?: string;
  useDeliveryAddressChecked?: string;
  streetDeliveryAddress?: string;
  streetNumberDeliveryAddress?: string;
  zipCodeDeliveryAddress?: string;
  cityDeliveryAddress?: string;
  orderedTariff?: string;
  tarif?: string;
  country?: string;
  yearlyGridSupplyKwh?: string;
  personsInHousehold?: number;
  feedinEnumerationInterest?: string;
  marketRegistrationId?: string | null;
  pvInstallationYear?: string;
}

export interface SITE_TECHNICAL_DATA {
  cancelContractType?: string;
  contractStartDate?: string;
  paymentDetails?: {
    account?: string;
    cardHolder?: string;
    iban?: string;
    consent?: boolean;
  };
  batterySetup?: {
    batteryInstalled?: string;
    batteryCapacity?: string;
  };
  pvSetup?: {
    pvInstalled?: string;
    pvPowerMaxKwp?: string;
    postalCode?: string;
  };
  wallboxInstalled?: string;
  meterNumber?: string;
  marketLocationId?: string;
  energyProvider?: string;
  energyProviderUuid?: string;

  smartMeterInstalled?: string;
  heatpumpInstalled?: string;
}

export interface FUNNEL_ORDER_RESPONSE {
  msgId: string;
  redirectUrl: string;
}

export interface BONUS {
  isActive: boolean;
  logicalId: string;
  endDate: string | null;
}

export interface SMART_CHARGING_WALLBOX_DATA {
  manufacturer: string;
  modelName: string;
  compatibilityStatus: string;
}

export interface MicroFrontendDetails {
  version: string;
  language: string;
  logicalId: string;
  themeLogicalId: string;
  callbackUrlSuccess: string;
  callbackUrlFailure: string;
  hemProvider?: string;
}

export interface EvsesCompatibility {
  modelName: string;
  manufacturer: string;
  compatibilityStatus: string;
}

export interface Orchestration {
  addOnBooked: string;
  attachedState: string;
  evOnboardingUrl: string;
  frontendFlow: string;
  termsAccepted: string;
}
